
import { useState } from "react";
import { Channel } from "@/lib/types";

export function useChannelDialogs(channels: Channel[]) {
  // Dialog control states
  const [isCreateChannelDialogOpen, setIsCreateChannelDialogOpen] = useState(false);
  const [isEditDialogOpen, setIsEditDialogOpen] = useState(false);
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  
  // Form states for create dialog
  const [newChannelName, setNewChannelName] = useState("");
  const [newChannelDescription, setNewChannelDescription] = useState("");
  const [isAnnouncementChannel, setIsAnnouncementChannel] = useState(false);
  const [isTemporaryChannel, setIsTemporaryChannel] = useState(false);
  const [autoDeleteAfter, setAutoDeleteAfter] = useState<number>(60);
  
  // Form states for edit dialog
  const [channelIdToEdit, setChannelIdToEdit] = useState<string | null>(null);
  const [editedChannelName, setEditedChannelName] = useState("");
  const [editedChannelDescription, setEditedChannelDescription] = useState("");
  const [editedIsAnnouncement, setEditedIsAnnouncement] = useState(false);
  const [editedIsTemporary, setEditedIsTemporary] = useState(false);
  const [editedAutoDeleteAfter, setEditedAutoDeleteAfter] = useState<number>(60);
  
  // State for delete dialog
  const [channelIdToDelete, setChannelIdToDelete] = useState<string | null>(null);

  const resetCreateFormState = () => {
    setNewChannelName("");
    setNewChannelDescription("");
    setIsAnnouncementChannel(false);
    setIsTemporaryChannel(false);
    setAutoDeleteAfter(60);
  };

  const handleOpenEditDialog = (channelId: string) => {
    const channelToEdit = channels.find(c => c.id === channelId);
    if (!channelToEdit) return;
    
    setChannelIdToEdit(channelId);
    setEditedChannelName(channelToEdit.name);
    setEditedChannelDescription(channelToEdit.description);
    setEditedIsAnnouncement(channelToEdit.isAnnouncement);
    setEditedIsTemporary(channelToEdit.isTemporary);
    setEditedAutoDeleteAfter(channelToEdit.autoDeleteAfter || 60);
    setIsEditDialogOpen(true);
  };

  const handleOpenDeleteDialog = (channelId: string) => {
    setChannelIdToDelete(channelId);
    setIsDeleteDialogOpen(true);
  };

  return {
    // Create dialog state
    isCreateChannelDialogOpen,
    setIsCreateChannelDialogOpen,
    newChannelName,
    setNewChannelName,
    newChannelDescription,
    setNewChannelDescription,
    isAnnouncementChannel,
    setIsAnnouncementChannel,
    isTemporaryChannel,
    setIsTemporaryChannel,
    autoDeleteAfter,
    setAutoDeleteAfter,
    
    // Edit dialog state
    isEditDialogOpen,
    setIsEditDialogOpen,
    channelIdToEdit,
    editedChannelName,
    setEditedChannelName,
    editedChannelDescription,
    setEditedChannelDescription,
    editedIsAnnouncement,
    setEditedIsAnnouncement,
    editedIsTemporary,
    setEditedIsTemporary,
    editedAutoDeleteAfter,
    setEditedAutoDeleteAfter,
    
    // Delete dialog state
    isDeleteDialogOpen,
    setIsDeleteDialogOpen,
    channelIdToDelete,
    
    // Helper functions
    resetCreateFormState,
    handleOpenEditDialog,
    handleOpenDeleteDialog
  };
}
